import { useState } from 'react';
import type { VelocityView } from '@mcpanel/core';
import { velocityApi } from '../api/velocity';
import { errorMessage, useApp } from '../app-context';
import { Dialog } from './ui';
import { Spinner } from './feedback';
function Actions({ data, reload, compact }: { data: VelocityView; reload: () => void; compact?: boolean }) {
  const { canOperate, notify } = useApp();
  const [confirm, setConfirm] = useState<'stop' | 'restart'>();
  const [busy, setBusy] = useState(false);
  const labels = { start: '起動', stop: '停止', restart: '再起動' };
  async function run(action: keyof typeof labels) {
    setBusy(true);
    try {
      await velocityApi[action]();
      setConfirm(undefined);
      reload();
      notify(`Velocity を${labels[action]}しました`);
    } catch (error) {
      notify(errorMessage(error), true);
    } finally {
      setBusy(false);
    }
  }
  if (!canOperate || !data.manageSupported) return null;
  return (
    <div className="row" style={{ gap: 6 }}>
      {(data.state === 'stopped'
        ? (['start'] as const)
        : data.state === 'running'
          ? (['stop', 'restart'] as const)
          : ([] as const)
      ).map((action) => (
        <button
          key={action}
          className={`btn ${compact ? 'small' : ''} ${action === 'start' ? 'primary' : action === 'stop' ? 'danger' : ''}`}
          disabled={busy}
          onClick={() => (action === 'start' ? void run(action) : setConfirm(action))}
        >
          {busy && <Spinner />}
          {labels[action]}
        </button>
      ))}
      {confirm && (
        <Dialog
          title={`Velocity を${labels[confirm]}`}
          onClose={() => setConfirm(undefined)}
          actions={
            <button className="btn danger" disabled={busy} onClick={() => void run(confirm)}>
              {busy && <Spinner />}
              {labels[confirm]}
            </button>
          }
        >
          <p>接続中の全プレイヤーが切断されます。{labels[confirm]}しますか？</p>
        </Dialog>
      )}
    </div>
  );
}
export function VelocityActions(props: Parameters<typeof Actions>[0]) {
  if (!props.data.manageSupported) return null;
  return <Actions {...props} />;
}
